import { StyledSelect } from "@/components/styles";
import { SelectBase } from "@/components";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

export default React.memo(function SelectDirections({
  directions = [],
  active: activeFromProps = {},
  placeholder,
  onChange,
  disabled,
  includeAllItemsVariant = false,
  reactOnAbsentServices = false,
  scrollTop = false,
  ...otherProps
}) {
  const active = activeFromProps || directions[0];
  const { t } = useTranslation("global");

  const { title: activeTitle, slug: activeSlug } = active;

  const handleChange = (e) => {
    const value = e.target.value;
    scrollTop && window.scrollTo(0, 0);
    onChange && onChange(value);
  };

  const handleClickOnDisabled = (e) => {
    e.stopPropagation();
  };

  return (
    <SelectBase title={activeTitle || placeholder} closeOnClick={true} disabled={disabled} {...otherProps}>
      {directions.map((direction) => {
        const { id, children, service_count, ...itemProps } = direction;

        return (
          <Fragment key={id}>
            <SelectItem
              activeSlug={activeSlug}
              onClick={reactOnAbsentServices && service_count === 0 ? handleClickOnDisabled : undefined}
              onChange={handleChange}
              disabled={reactOnAbsentServices && service_count === 0}
              {...itemProps}
            />
            {children?.length > 0 &&
              children.map((child) => {
                const { id, service_count, ...childProps } = child;
                return (
                  <SelectItem
                    key={id}
                    activeSlug={activeSlug}
                    onClick={reactOnAbsentServices && service_count === 0 ? handleClickOnDisabled : undefined}
                    onChange={handleChange}
                    disabled={reactOnAbsentServices && service_count === 0}
                    {...childProps}
                    isChild
                  />
                );
              })}
          </Fragment>
        );
      })}
      {includeAllItemsVariant && <SelectItem activeSlug={activeSlug} title={t("services.allDirections")} onChange={handleChange} />}
    </SelectBase>
  );
});

function SelectItem(props) {
  const { activeSlug, title, slug, onChange, onClick, isChild, disabled = false } = props;
  const checked = slug === activeSlug;

  return (
    <StyledSelect.Item isActive={checked} isChild={isChild} disabled={disabled}>
      <StyledSelect.Radio>
        <StyledSelect.RadioInput type="radio" name="direction" value={slug} checked={checked} onChange={onChange} disabled={disabled} />
        <StyledSelect.RadioTitle onClick={onClick}>{title}</StyledSelect.RadioTitle>
      </StyledSelect.Radio>
    </StyledSelect.Item>
  );
}
